<template>
  <layout-basic>
    <div slot="hero-body" class="container has-text-centered">
      <h1 class="title">
        Cloudprinter to Zoho CRM
      </h1>
    </div>


    <div class="section">
      Contact Cloudprinter.com support team if you need help - support@cloudprinter.com
    </div>

  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/LayoutBasic'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    LayoutBasic
  },

  data () {

    return {
      backendVersions: {},
      frontendVersions: {},
      isLoading: false,
      zohoAuthUrl: null,
    }
  },

  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>
